import type { ProductSource } from '@/shared/hooks/api/productSource'
import {
  PRODUCT_SOURCE_XLSM_MIME,
  PRODUCT_SOURCE_XLSX_MIME,
} from './productSourceFileTypes'

const RAG_INGESTED_SOURCE_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/png',
  PRODUCT_SOURCE_XLSX_MIME,
  PRODUCT_SOURCE_XLSM_MIME,
])

/** E-plan extraction only supports PDF/image sources (not spreadsheets). */
const EPLAN_SOURCE_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/png',
])

export type ProductSourcePreviewMode = 'pdf' | 'image' | 'none'

export function isRagIngestableSourceType(type: string): boolean {
  return RAG_INGESTED_SOURCE_TYPES.has(type)
}

export function isRagIngestedProductSource(source: ProductSource): boolean {
  if (source.ingestionStatus !== 'COMPLETED') {
    return false
  }
  return isRagIngestableSourceType(source.type)
}

export function isInspectableProductSource(
  source: Pick<ProductSource, 'type' | 'ingestionStatus'>
): boolean {
  if (!isRagIngestableSourceType(source.type)) {
    return false
  }
  return (
    source.ingestionStatus === 'COMPLETED' ||
    source.ingestionStatus === 'FAILED'
  )
}

export function getProductSourcePreviewMode(
  sourceType: string
): ProductSourcePreviewMode {
  if (sourceType === 'application/pdf') {
    return 'pdf'
  }
  if (sourceType === 'image/jpeg' || sourceType === 'image/png') {
    return 'image'
  }
  return 'none'
}

export function isEplanSelectableProductSource(source: ProductSource): boolean {
  if (!isRagIngestedProductSource(source)) {
    return false
  }
  return EPLAN_SOURCE_TYPES.has(source.type)
}
